import React, { useState } from 'react';
import { AlertTriangle, X, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DeleteGroupModal = ({ isOpen, onClose, onConfirm, groupName, isDeleting }) => {
  const { t } = useTranslation();
  const [confirmText, setConfirmText] = useState('');
  const expectedText = `DELETE ${groupName}`;
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl border border-red-500/30 max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-red-600 dark:text-red-400 flex items-center space-x-2">
              <AlertTriangle size={20} />
              <span>{t('groups.deleteGroupModal.title')}</span>
            </h2>
            <button onClick={onClose} className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg" disabled={isDeleting}>
              <X size={18} />
            </button>
          </div>

          <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-500/30 rounded-xl">
            <p className="text-red-600 dark:text-red-300 mb-3">
              {t('groups.deleteGroupModal.warning', { groupName })}
            </p>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
              {t('groups.deleteGroupModal.typeToConfirm')} <span className="font-mono bg-gray-100 dark:bg-gray-900 px-2 py-1 rounded text-red-600 dark:text-red-400">{expectedText}</span> {t('groups.deleteGroupModal.toConfirmSuffix')}
            </label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="w-full bg-white dark:bg-gray-900 border border-red-500/50 text-gray-900 dark:text-white px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500"
              placeholder={expectedText}
              disabled={isDeleting}
            />
          </div>

          <div className="flex space-x-3">
            <button onClick={onClose} className="flex-1 px-4 py-3 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-xl" disabled={isDeleting}>
              {t('groups.deleteGroupModal.cancel')}
            </button>
            <button
              onClick={() => onConfirm?.()}
              disabled={confirmText !== expectedText || isDeleting}
              className="flex-1 px-4 py-3 bg-red-600 hover:bg-red-700 text-white rounded-xl disabled:opacity-50 flex items-center justify-center space-x-2"
            >
              {isDeleting ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  <span>{t('groups.deleteGroupModal.deleting')}</span>
                </>
              ) : (
                <>
                  <Trash2 size={16} />
                  <span>{t('groups.deleteGroupModal.confirmButton')}</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteGroupModal;
